// extracted by mini-css-extract-plugin
export default {"paginationContainer":"MosBjz6XDCXdZ6N4K8nv","noProjectsHint":"IvSKKatasi4TTeJL2hDQ"};